<script>
  import { login } from '../stores/auth.js';
  import { colorMode, initAppearance } from '../stores/theme.js';
  import { t } from '../i18n/index.js';
  import { onMount } from 'svelte';
  import { Sun, Moon, LogIn } from '../lib/icons/index.js';
  import ErrorBanner from '../components/ErrorBanner.svelte';
  import Brand from '../components/Brand.svelte';

  onMount(() => { initAppearance(); });

  let email = '';
  let password = '';
  let error = '';
  let loading = false;

  async function handleSubmit(e) {
    e.preventDefault();
    error = '';
    loading = true;

    const result = await login(email, password);
    if (!result.success) {
      error = result.error;
    }
    loading = false;
  }
</script>

<div class="login-screen">
  <div class="absolute top-4 right-4">
    <button type="button" class="icon-button" on:click={() => colorMode.toggle()}
      aria-label={$colorMode === 'dark' ? $t('nav.lightMode') : $t('nav.darkMode')}
      title={$colorMode === 'dark' ? $t('nav.lightMode') : $t('nav.darkMode')}>
      {#if $colorMode === 'dark'}
        <Sun size={18} aria-hidden="true" />
      {:else}
        <Moon size={18} aria-hidden="true" />
      {/if}
    </button>
  </div>

  <main class="w-full max-w-md">
    <div class="flex justify-center mb-8">
      <Brand />
    </div>

    <div class="card p-8 max-mobile:p-6">
      <h1 class="text-2xl font-display text-heading mb-2 text-center">{$t('auth.loginTitle')}</h1>
      <p class="text-sm text-center mb-6 text-muted">{$t('auth.loginSubtitle')}</p>

      <ErrorBanner {error} raw />

      <form on:submit={handleSubmit} class="space-y-5">
        <div>
          <label for="email" class="label">{$t('auth.email')}</label>
          <input
            id="email"
            type="email"
            bind:value={email}
            required
            autocomplete="email"
            class="input"
            placeholder={$t('auth.emailPlaceholder')}
          />
        </div>

        <div>
          <label for="password" class="label">{$t('auth.password')}</label>
          <input
            id="password"
            type="password"
            bind:value={password}
            required
            autocomplete="current-password"
            class="input"
            placeholder={$t('auth.passwordPlaceholder')}
          />
        </div>

        <button type="submit" disabled={loading} class="btn btn-primary w-full gap-2">
          {#if loading}
            <span class="animate-pulse">{$t('app.accessing')}</span>
          {:else}
            <LogIn size={18} aria-hidden="true" />
            <span>{$t('auth.loginTitle')}</span>
          {/if}
        </button>
      </form>

      <p class="mt-5 text-center text-xs text-muted">
        <span class="font-bold">{$t('auth.forgotPassword')}</span> {$t('auth.forgotPasswordHint')}
      </p>

      <!-- Someone handed an "API key" by their consultant will try it here.
           auth.apiKeyHelp was written for exactly that moment: it says what the
           key is for and that an end user signs in with email and password. -->
      <p class="mt-3 text-center text-xs text-muted">
        {$t('auth.apiKeyHelp')}
      </p>
    </div>

    <p class="text-center mt-6 text-xs text-muted">
      {$t('app.fullName')}
    </p>
  </main>
</div>
